// Listes côté client — sélecteur de taille de page, recherche globale, en-têtes
// triables et pagination numérotée — comme dans kopilot. Sur demande : envelopper
// le tableau dans un élément portant data-table-list (voir
// app/views/admin/shared/_table_list_toolbar.html.erb).
//
// Les lignes sont filtrées sur leur texte et triées sur le data-sort-value de
// chaque cellule (à défaut, son texte).

const PAGINATION_ICONS = {
  previous: '<i class="mdi mdi-chevron-left"></i>',
  next: '<i class="mdi mdi-chevron-right"></i>'
}

export function initTableLists() {
  document.querySelectorAll("[data-table-list]").forEach((root) => {
    if (root.dataset.tableListWired) return
    root.dataset.tableListWired = "true"
    setupTableList(root)
  })
}

function setupTableList(root) {
  const tbody = root.querySelector("tbody")
  const rows = Array.from(tbody.querySelectorAll("tr[data-row]"))
  const emptyRow = tbody.querySelector("tr[data-empty-row]")
  const pageSizeSelect = root.querySelector("[data-table-list-page-size]")
  const searchInput = root.querySelector("[data-table-list-search]")
  const info = root.querySelector("[data-table-list-info]")
  const pagination = root.querySelector("[data-table-list-pagination]")
  const headers = Array.from(root.querySelectorAll("thead th"))

  const state = { pageSize: Number(pageSizeSelect?.value || 10), pageIndex: 0, query: "", sortColumn: null, sortDir: null }

  const cellValue = (row, column) => {
    const cell = row.cells[column]
    if (!cell) return ""
    return cell.dataset.sortValue ?? cell.textContent.trim()
  }

  const compare = (a, b) => {
    const numA = Number(a)
    const numB = Number(b)
    if (a !== "" && b !== "" && !Number.isNaN(numA) && !Number.isNaN(numB)) return numA - numB
    return a.localeCompare(b, "fr", { sensitivity: "base" })
  }

  const render = () => {
    let visible = rows.filter((row) => !state.query || row.textContent.toLowerCase().includes(state.query))

    if (state.sortColumn !== null) {
      const direction = state.sortDir === "asc" ? 1 : -1
      visible = [...visible].sort((a, b) => direction * compare(cellValue(a, state.sortColumn), cellValue(b, state.sortColumn)))
    }

    const pageCount = Math.max(1, Math.ceil(visible.length / state.pageSize))
    state.pageIndex = Math.min(state.pageIndex, pageCount - 1)
    const start = state.pageIndex * state.pageSize
    const pageRows = visible.slice(start, start + state.pageSize)

    rows.forEach((row) => { row.hidden = true })
    pageRows.forEach((row) => {
      row.hidden = false
      tbody.appendChild(row) // conserve l'ordre du tri dans le DOM
    })
    if (emptyRow) {
      emptyRow.hidden = visible.length > 0
      tbody.appendChild(emptyRow)
    }

    if (info) info.textContent = `Affichage de ${pageRows.length} sur ${visible.length} résultats`
    if (pagination) renderPagination(pageCount)
  }

  const renderPagination = (pageCount) => {
    const item = (label, index, { disabled = false, active = false, extraClass = "" } = {}) =>
      `<li class="paginate_button page-item ${extraClass} ${disabled ? "disabled" : ""} ${active ? "active" : ""}">` +
      `<a href="#" class="page-link" data-page="${index}">${label}</a></li>`

    let html = item(PAGINATION_ICONS.previous, state.pageIndex - 1, { disabled: state.pageIndex === 0, extraClass: "previous" })
    for (let i = 0; i < pageCount; i++) html += item(i + 1, i, { active: i === state.pageIndex })
    html += item(PAGINATION_ICONS.next, state.pageIndex + 1, { disabled: state.pageIndex >= pageCount - 1, extraClass: "next" })
    pagination.innerHTML = html
  }

  pagination?.addEventListener("click", (event) => {
    const link = event.target.closest("a[data-page]")
    if (!link) return
    event.preventDefault()
    if (link.closest(".disabled")) return
    state.pageIndex = Number(link.dataset.page)
    render()
  })

  pageSizeSelect?.addEventListener("change", () => {
    state.pageSize = Number(pageSizeSelect.value)
    state.pageIndex = 0
    render()
  })

  let searchTimeout
  searchInput?.addEventListener("input", () => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      state.query = searchInput.value.trim().toLowerCase()
      state.pageIndex = 0
      render()
    }, 300)
  })

  headers.forEach((th, column) => {
    if (!th.hasAttribute("data-sortable")) return
    th.addEventListener("click", () => {
      state.sortDir = state.sortColumn === column && state.sortDir === "asc" ? "desc" : "asc"
      state.sortColumn = column
      headers.forEach((h) => h.classList.remove("sorting_asc", "sorting_desc"))
      th.classList.add(state.sortDir === "asc" ? "sorting_asc" : "sorting_desc")
      render()
    })
  })

  render()
}
